import { useTranslation } from 'react-i18next'
import { useNavigate, useOutletContext } from 'react-router'

import { ConnectionSetupRoutes } from 'app/application/types'
import { ConnectionIcon, combineClassnames } from 'app/common/presentation'
import { Checkmark2Icon, EllipseIcon, InnkeeprIcon } from 'app/common/presentation/icons'

import { Button } from 'components'

import setupStyles from '../Setup.module.scss'
import { StepContext } from './StepWithConnectionAndAccounts'
import styles from './Steps.module.scss'

const ConnectionVerified = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('connections')

  const { accounts, connection } = useOutletContext<StepContext>()

  // amazon only stores the token for now, so this is the last step
  const isLastStep = connection.name === 'amazon'

  return (
    <div className={combineClassnames(styles.step, styles.connectionVerified)}>
      <div className={setupStyles.form}>
        <div className={styles.connection}>
          <div className={styles.innkeepr}>
            <InnkeeprIcon />
          </div>
          <div className={styles.dots}>
            <EllipseIcon />
            <EllipseIcon />
            <EllipseIcon />
          </div>
          <div className={styles.connection}>
            <ConnectionIcon connection={connection} />
            <Checkmark2Icon className={styles.check} />
          </div>
        </div>
        <div className={styles.message}>{t('setup.connectionVerified.description')}</div>
      </div>
      <div className={setupStyles.actions}>
        <Button onClick={() => void navigate(-1)} variant="secondary">
          {t('setup.actions.back')}
        </Button>
        <Button
          onClick={(e) => {
            e.stopPropagation()

            if (isLastStep) {
              void navigate(`/connections/${connection.name}`, { replace: true })
              return
            }

            void navigate(`../${ConnectionSetupRoutes.Settings}`, {
              state: { accounts, connection },
            })
          }}
        >
          {t(isLastStep ? 'setup.actions.finish' : 'setup.actions.next')}
        </Button>
      </div>
    </div>
  )
}

export default ConnectionVerified
